import {ApiItem} from 'lib/api/api-item';
import {ApiStore} from 'lib/api/django-restframework/api-store';
import JSONSerializable from 'lib/serialization/json-serializable';

export class CMSItem extends ApiItem {
}

export class CMSStore extends ApiStore {

    constructor(options) {
        super(options);
        this.delegate = this;
    }

    item() {
        return new CMSItem({
            delegate: this,
        });
    }

    load(key) {
        const request = this.api.get({
            path: `cms/content-items/${key}`,
        });

        return super.load({
            request,
        });
    }
} 
